import styled from "styled-components";

export const ContainerBackLogin = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 26rem;
`;
